import { SET_CUSTOM_FIELD_3 } from 'actions';

export function setCustomField3(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_3 };
}
